import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  TextField,
  Typography,
  Stack,
  Divider,
  Button,
  Box,
} from "@mui/material";
import { apiCallChangePass } from "../../../Core/Apicall";
import { useSelector, useDispatch } from "react-redux";
import { clearProfileData, clearToken } from "../../../Redux/Reducers/GlobalVar";
import { RootState } from "../../../Redux/Store";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";

type ChangePasswordProps = {
  onClose: () => void;
};

const ChangePassword = ({ onClose }: ChangePasswordProps) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const userdata: any = useSelector((state: RootState) => state.global.token);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(clearToken());
    dispatch(clearProfileData());

    navigate(`/admin/login`);
  };

  useEffect(() => {
    // If your API/userdata has an oldPassword stored
    if (userdata?.data?.oldPassword) {
      setOldPassword("");
    }
  }, [userdata]);

  const handleChangePassword = async () => {
    try {
      const userId = userdata?.data?.userId;
      if (!oldPassword) {
        toast.error("Please enter your old password");
        return;
      }

      if (!newPassword) {
        toast.error("Please enter a new password");
        return;
      }
      if (newPassword !== confirmPassword) {
        toast.error("New password and confirm password do not match");
        return;
      }

      const response = await apiCallChangePass({
        userId,
        oldPassword,
        newPassword,
      });

      toast.success(response?.message || "Password Changed Successfully");

      // clear inputs
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");

      // 🚪 automatically logout after password change
      setTimeout(() => {
        handleLogout();
      }, 1500);
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong. Try again!");
    }
  };

  const handleCancel = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    onClose();
  };

  return (
    <div style={{ padding: "10px 40px 10px 40px" }}>
      {/* <Paper
        elevation={6}
        sx={{
          p: 4,
          borderRadius: 4,
          maxWidth: 420,
          mx: "auto",
          // boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
          backgroundColor: "#fff",
        }}
      > */}
      <Typography
        variant="h6"
        gutterBottom
        fontWeight="bold"
        align="center"
        sx={{ mb: 1 }}
      >
        🔒 Change Password
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Stack spacing={2}>
        <TextField
          type={showOld ? "text" : "password"}
          label="Old Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          size="small"
          style={{ width: "22rem" }}
          fullWidth
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowOld(!showOld)} edge="end">
                  {showOld ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          type={showNew ? "text" : "password"}
          label="New Password"
          value={newPassword}
          style={{ width: "22rem" }}
          onChange={(e) => setNewPassword(e.target.value)}
          size="small"
          fullWidth
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowNew(!showNew)} edge="end">
                  {showNew ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          type={showConfirm ? "text" : "password"}
          label="Confirm New Password"
          value={confirmPassword}
          style={{ width: "22rem" }}
          onChange={(e) => setConfirmPassword(e.target.value)}
          size="small"
          fullWidth
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowConfirm(!showConfirm)}
                  edge="end"
                >
                  {showConfirm ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* Action Buttons */}
        <Box display="flex" justifyContent="space-between" mt={2}>
          <Button
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              py: 1.2,
              px: 3,
              bgcolor: "black",
              "&:hover": { bgcolor: "#333" },
            }}
            onClick={handleChangePassword}
            fullWidth
          >
            Update
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              py: 1.2,
              px: 3,
              ml: 2,
            }}
            onClick={handleCancel}
            fullWidth
          >
            Cancel
          </Button>
        </Box>
      </Stack>

      {/* <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
        closeButton={false}
      /> */}
      {/* </Paper> */}
    </div>
  );
};

export default ChangePassword;
